module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4wgl6"))).then(() => module.bundle.root('dsisd'));